import { AxiosStatic } from 'axios';
import { Store } from 'redux';
import { API_DOMAIN, CHAT_DOMAIN } from '../../app/constants';
import { actions } from '../../app/store/ducks/auth.duck';
import { IAppState, TAppActions } from '../../app/store/rootDuck';

export function removeCSSClass(ele: HTMLElement, cls: string) {
  const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
  ele.className = ele.className.replace(reg, ' ');
}

export function addCSSClass(ele: HTMLElement, cls: string) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

export function setupAxios(
  axios: AxiosStatic,
  store: Store<IAppState, TAppActions>,
  ChatSocket: any
) {
  axios.defaults.baseURL = API_DOMAIN;
  axios.interceptors.request.use(
    config => {
      if (!config.baseURL || config.baseURL === API_DOMAIN) {
        const {
          auth: { authToken },
        } = store.getState();

        if (authToken) {
          config.headers.common['X-AUTH-TOKEN'] = authToken;
        }
      } else if (config.baseURL === '/api/v4' || config.baseURL === CHAT_DOMAIN) {
        const chatAuthToken = ChatSocket.myAuthToken;
        if (chatAuthToken) {
          config.headers.Authorization = `BEARER ${chatAuthToken}`;
        }
        // console.log(
        //   `--- ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`,
        //   chatAuthToken === 'hdqxrwcxtbbppbmdkuiidu56wr' ? 'ADMIN' : chatAuthToken
        // );
      }
      return config;
    },
    err => Promise.reject(err)
  );
  axios.interceptors.response.use(undefined, error => {
    if (!error?.response) {
      const {
        auth: { emptyResErrAttempts },
      } = store.getState();

      if (emptyResErrAttempts >= 3) {
        store.dispatch(actions.setEmptyResErrAttempts(0));
        return Promise.reject(error);
      }

      return new Promise(async resolve => {
        // console.log('resend after 1 second...');
        await new Promise(r => setTimeout(r, 1000));
        // console.log('attempt', emptyResErrAttempts);

        store.dispatch(actions.setEmptyResErrAttempts(emptyResErrAttempts + 1));
        resolve(Promise.resolve(axios.request(error.config)));
      });
    } else {
      if (
        error?.response?.status == 403 &&
        (error?.response?.message === 'Аутентификация прошла с ошибкой, нет доступа' ||
          error?.response?.data?.message === 'Аутентификация прошла с ошибкой, нет доступа')
      ) {
        store.dispatch(actions.logout());
      }
      return Promise.reject(error);
    }
  });
}

/*  removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
 */
export function removeStorage(key: string) {
  try {
    localStorage.setItem(key, '');
    localStorage.setItem(key + '_expiresIn', '');
  } catch (e) {
    console.log(
      'removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e)
    );
    return false;
  }
  return true;
}

/*  getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
 */
export function getStorage(key: string) {
  const now = Date.now(); //epoch time, lets deal only with integer
  // set expiration for storage
  let expiresIn: string | null | number = localStorage.getItem(key + '_expiresIn');
  if (expiresIn === undefined || expiresIn === null) {
    expiresIn = 0;
  }

  expiresIn = Math.abs(+expiresIn);
  if (expiresIn < now) {
    // Expired
    removeStorage(key);
    return null;
  } else {
    try {
      const value = localStorage.getItem(key);
      return value;
    } catch (e) {
      console.log(
        'getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e)
      );
      return null;
    }
  }
}
/*  setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
 */
export function setStorage(key: string, value: string, expires?: number) {
  if (expires === undefined || expires === null) {
    expires = 24 * 60 * 60; // default: seconds for 1 day
  }

  const now = Date.now(); //millisecs since epoch time, lets deal only with integer
  const schedule = now + expires * 1000;
  try {
    localStorage.setItem(key, value);
    localStorage.setItem(key + '_expiresIn', JSON.stringify(schedule));
  } catch (e) {
    console.log(
      'setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e)
    );
    return false;
  }
  return true;
}
